import { createApp } from 'vue'

import { settings } from './variables.js'
import axios from 'axios'

import { provideGlobalSettings } from './vue_mixins/SettingsMixin.vue'

import ContactForm from './vue_components/contacts/ContactForm.vue'


const app = createApp({
  components: {
    ContactForm
  },
  data() {
    return {
    }
  }
})

// Глобальная настройка axios
app.config.globalProperties.$axios = axios
axios.defaults.baseURL = settings.apiBaseUrl
axios.defaults.withCredentials = true

const siteSettings = provideGlobalSettings()
app.provide('globalSettings', siteSettings)


// Монтирование приложения
app.mount('#app')

async function setupCSRF() {
  try {
    const response = await axios.get('/csrf/')
    const csrfToken = response.data.csrfToken

    // Установите токен в заголовки всех запросов
    axios.defaults.headers.common['X-CSRFToken'] = csrfToken
  } catch (error) {
    console.error('Не удалось получить CSRF-токен:', error)
  }
}

//setupCSRF()
